module.exports = __webpack_public_path__ + "static/img/zb.4180c8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hk/zb.png
// module id = 6NL4
// module chunks = 1